module.exports = __webpack_public_path__ + "static/media/twitter.cabacfd3.svg";